import { render, staticRenderFns } from "./notionInvestment.vue?vue&type=template&id=ecba18b8&scoped=true&"
import script from "./notionInvestment.vue?vue&type=script&lang=js&"
export * from "./notionInvestment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecba18b8",
  null
  
)

export default component.exports